// import external dependencies
import 'jquery';
import "simplelightbox";
import "magnific-popup";
import "bootstrap"

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from 'vue'

Vue.component('st-enoch-search', require('./components/StEnochSearch.vue').default)
Vue.component('st-enoch-shops', require('./components/StEnochShops.vue').default)

if( $('#search').length > 0 ) {
	const search = new Vue({
		el: '#search'
	});
}

if( $('#vue').length > 0 ) {
	const shops = new Vue({
		el: '#vue'
	});
}

$(document).on('click', 'button', function() {
	const button = $(this)
	axios.get('/wp-admin/admin-ajax.php', {
		params: {
			action: 'st_enoch_get_posts',
			page: button.data('page'),
			type: button.data('type'),
			perPage: button.data('per-page')
		}
	})
	.then(response => {
		if( $.trim(response.data.html) !== '' ) {
			$(button.data('container')).append(response.data.html)
			button.data('page', response.data.nextPage)
		}
		if( ! response.data.hasMore ) {
			button.remove()
		}
	})
});

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js